export const styles = {
  wrapper: {
    minHeight: '100px',
    position: 'relative',
    boxSizing: 'border-box',
    width: '100%',
  },
}
